/**
 * The phone's bottom bar icons: each door's and More's, as MobileNav draws them on the bar. FTUX - Getting Started
 * shows the same icon before a door's name when its map names the bar's doors, so its words point at what the owner
 * sees (a door added in studioMenu.ts gets its icon here, the typecheck asks).
 */
import React from 'react';

import type { PhoneBarDoorKey } from '../../studioMenu';
import { MarketingGlyph } from '../MarketingGlyph';
import { MaskIcon } from '../MaskIcon';
import { WebsiteGlyph } from '../WebsiteGlyph';

const CDN = 'https://micros-t.b-cdn.net';

/** Each bottom-bar door's icon. */
export const BAR_ICON: Readonly<Record<PhoneBarDoorKey, React.ReactElement>> = {
  home: <MaskIcon className="icon-mask" src={`${CDN}/studio-menu-icon-home-1779968968258.svg`} />,
  // Stats wears the pulse-line glyph (the files are named the other way round), like the rail.
  stats: <MaskIcon className="icon-mask" src={`${CDN}/studio-menu-icon-pulse-1779968968265.svg`} />,
  marketing: <MarketingGlyph className="icon-glyph" />,
  website: <WebsiteGlyph className="icon-glyph" />,
};

/** The bar's More button icon (it opens the More drawer). */
export const MORE_ICON = <MaskIcon className="icon-mask" src={`${CDN}/studio-menu-icon-more-1779969217663.svg`} />;
